export default {
  'pages.productDetail.home': '首页',
  'pages.productDetail.addCart': '把商品加入意向单',
  'pages.productComDetail.addCart': '立即生产',
  'pages.productDetail.interestedDesc': '如您对商品感兴趣或想快速了解，请点击',
  'pages.productDetail.onlineService': '在线客服',
  'pages.productDetail.selectDesc': '请选择需要的工艺',
  'pages.productDetail.selectMaterial': '请选择需要的材质',
  'pages.productDetail.down1': '下载印刷区说明',
  'pages.productDetail.down2': '下载爆炸图',
  'pages.productDetail.collapse1': '商品详情',
  'pages.productDetail.collapse2': '材质信息',
  'pages.productDetail.collapse3': '采购流程',
  'pages.productDetail.collapse4': '采购说明',
  'pages.productDetail.signTitle': '您想要看更多内容吗？',
  'pages.productDetail.signSubTitle': '请登录以获取详细信息。',
  'pages.productDetail.signBtn': '登录',
};
